<template>
  <div class="table_container">
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
          background: '#EFEFEF',
          color: '#000',
          borderColor: '#dcdfe6'
        }"
      
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
      :cell-style="cellStyle"
    >
    
  <el-table-column
    prop="type"
    label="分类"
    width="150"
    class="bgheader"
    >
    <template slot-scope="scope">
         
          <div style="
        color:#000;font-weight: bold;">
            {{ scope.row.type }}
          </div>
        </template>
  </el-table-column>
  <el-table-column :label="year+'年'+type+'单'" align="center">
    <el-table-column
      prop="annualCumulative"
      label="年度累计"
    
      style="background-color: #EFEFEF;"
      width="120">
    </el-table-column>
      <el-table-column
        prop="cutoffMonths"
         :label="'截止'+(Number(month)+num)+'月'"
        width="120">
      </el-table-column>
      <el-table-column
        prop="completionRate"
        label="完成率"
        width="120">
      </el-table-column>
      <el-table-column
        prop="oneData"
        label="1月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'oneData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.oneData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.oneData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="twoData"
        label="2月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'twoData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.twoData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.twoData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="threeData"
        label="3月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'threeData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.threeData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.threeData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fourData"
        label="4月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'fourData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.fourData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.fourData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fiveData"
        label="5月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'fiveData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.fiveData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.fiveData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sixData"
        label="6月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'sixData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.sixData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.sixData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sevenData"
        label="7月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'sevenData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.sevenData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.sevenData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="eightData"
        label="8月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'eightData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.eightData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.eightData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="nineData"
        label="9月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'nineData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.nineData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.nineData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="tenData"
        label="10月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'tenData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.tenData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.tenData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="elevenData"
        label="11月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'elevenData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.elevenData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.elevenData }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="twelveData"
        label="12月"
        width="120">
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'twelveData' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.twelveData"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.twelveData }}
          </div>
        </template>
      </el-table-column>
  </el-table-column>
    </el-table>
   
  </div>
</template>

<script>
export default {

  data() {
    return {
      tableData:[],
      editField: "", // 编辑单元格
      editIndex: -1, // 编辑行索引
      year:'',
      month:'',
      type:'',
      num:0
    };
  },
  methods: {
    getData(){
      return this.tableData
    },
    init(data,queryParams,type) {
      this.tableData = (data||[])
      
      this.year = queryParams.years
      this.month = Number(queryParams.months);
      if(type==1){
        this.type = '关'
        this.num = 1
      }else{ 
        this.type= '接'
        this.num = 2
      }
    },

    cellStyle({columnIndex}){
      if (columnIndex == 0||columnIndex == 1||columnIndex == 2||columnIndex == 3 ) {
        return { "background-color": "#EFEFEF !important",
          "borderColor": '#dcdfe6',
         };
      }
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
     
      
  },

  
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },

    // 点击单元格编辑
    handleColumn(field, index) {
      if (this.$route.query.operateType === "查看") return;
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  .bgheader{
    background-color: #EFEFEF;
  }
}
</style>
